import React,{useMemo,useState} from 'react';
import {PC28Roads} from './PC28Roads';
import {PC28NumberAnalysis} from './PC28NumberAnalysis';
import {PC28PredictionPage} from './PC28PredictionPage';
import {PC28DragonPage} from './PC28DragonPage';
import {PC28StatsPage} from './PC28StatsPage';
import './PC28Workspace.css';
const TABS=[['result','结果'],['trend','走势露珠'],['number','号码分析'],['prediction','智能预测'],['dragon','长龙检测'],['missing','遗漏查询'],['opened','已开统计']];
export function PC28Workspace({children,history,disabled,targetIssue,targetTime,activeTab,onTabChange}) {
  const [localTab,setLocalTab]=useState('result');
 const tab=activeTab??localTab, setTab=onTabChange||setLocalTab;
  const sample=useMemo(()=>history.slice(0,60),[history]);
  return <div className="pc-workspace">
    <nav className="pc-page-tabs" role="tablist" aria-label="PC28分析页面">{TABS.map(([id,label],index)=><button key={id} id={`pc-tab-${id}`} type="button" role="tab" aria-selected={tab===id} aria-controls="pc-page-content" tabIndex={tab===id?0:-1} onClick={()=>setTab(id)} onKeyDown={e=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?TABS.length-1:(index+(e.key==='ArrowLeft'?-1:1)+TABS.length)%TABS.length;
      setTab(TABS[next][0]);e.currentTarget.parentElement.children[next].focus();
    }}>{label}</button>)}</nav>
    <div id="pc-page-content" role="tabpanel" aria-labelledby={`pc-tab-${tab}`}>
      {tab==='result'?children:<section className="panel pc-detail-panel">
        <div className="pc-page-heading"><h2>{TABS.find(([id])=>id===tab)[1]}</h2></div>
        {disabled&&<p className="pc-sample-note">数据更新中、过期或不连续，以下为已有记录；暂停新增开奖前预测记录。</p>}
        {tab==='trend'&&<PC28Roads history={sample}/>}
        {tab==='number'&&<PC28NumberAnalysis history={sample}/>}
        {tab==='prediction'&&<PC28PredictionPage history={sample} disabled={disabled} targetIssue={targetIssue} targetTime={targetTime}/>}
        {tab==='dragon'&&<PC28DragonPage history={sample} disabled={disabled}/>}
        {(tab==='missing'||tab==='opened')&&<PC28StatsPage history={sample} mode={tab}/>}
      </section>}
    </div>
  </div>;
}
